import React from 'react'
import cx from 'classnames'
import Grid from '@material-ui/core/Grid'
import MuiButton from '@material-ui/core/Button'
import { dismissPopover } from 'services/OverlayService'
import TealToolTip from 'components/TealToolTip'

export default ({
  selectedDeals,
  disabled,
  handleDeselectAll,
  handleCompareSelectedDeals,
  setSignUpModalIsOpen,
  isLogged
}) => (
  <Grid container spacing={2} justify='space-around'>
    <Grid item xs={12} sm={12} md={6} lg={4}>
      <ClearActionButton {...{ selectedDeals, handleDeselectAll, isLogged, setSignUpModalIsOpen }} />
    </Grid>
    <Grid item xs={12} sm={12} md={6} lg={8}>
      <CompareActionButton {...{
        disabled,
        selectedDeals,
        handleCompareSelectedDeals,
        isLogged,
        setSignUpModalIsOpen
      }}
      />
    </Grid>
  </Grid>
)

const ClearActionButton = ({ selectedDeals, handleDeselectAll: onClick, setSignUpModalIsOpen, isLogged }) => {
  const label = selectedDeals.length === 0 ? 'Clear selection' : `Clear selection (${selectedDeals.length})`
  const disabled = selectedDeals.length < 1

  return (
    <HeaderActionButton type='CLEAR' {...{ label, disabled, onClick, setSignUpModalIsOpen, isLogged }} />
  )
}

const CompareActionButton = ({
  disabled,
  selectedDeals,
  handleCompareSelectedDeals: onClick,
  setSignUpModalIsOpen,
  isLogged
}) => {
  const suffix = disabled ? '' : `(${selectedDeals.length})`
  const label = `Compare selected deals from all sessions ${suffix}`

  return (
    <HeaderActionButton
      type='COMPARE'
      description={disabled ? 'Select 2 or more deals to compare' : undefined}
      {...{
        label,
        disabled,
        onClick,
        setSignUpModalIsOpen,
        isLogged
      }}
    />
  )
}

const HeaderActionButton = ({ type, disabled, onClick, label, description, className, setSignUpModalIsOpen, isLogged }) => {
  const handleOnClick = (e) => {
    dismissPopover(e.target)
    if (type === 'COMPARE' && !isLogged) {
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    } else {
      onClick()
    }
  }

  return (
    <TealToolTip title={description || ''}>
      <div
        className={cx('cadet-blue bg-white br2', className)}
      >
        <Button {...{ disabled, handleOnClick, label }} />
      </div>
    </TealToolTip>
  )
}

const Button = ({ disabled = false, handleOnClick: onClick, label }) => {
  const classes = {
    root: cx(
      'w-100 tracked-cosy b ttn f7-m',
      { 'black header-action-button': !disabled },
      { 'bg-white header-action-button-disabled': disabled }
    )
  }

  return (
    <MuiButton {...{ disabled, classes, onClick }}>
      {label}
    </MuiButton>
  )
}
